/*
 * @Description: 
 * @Author: xiong.zhou@dmall.com
 * @Date: 2022-03-18 10:29:17
 * @LastEditors: xiong.zhou@dmall.com
 * @LastEditTime: 2025-06-09 21:47:28
 */
import request from '../request';

export function login(params) {
    return request('/user/logon', {
        type: 'formData',
        method: 'POST',
        params
    });
}

//微信扫码后回调
export function wxLogin(params) {
    return request('/user/weixinlogin', {
        type: 'formData',
        method: 'POST',
        params
    });
}

//微信扫码后自动登录
export function autoLogin(params) {
    return request('/user/auto/login', {
        method: 'GET',
        params
    });
}

//用户绑定平台账号
export function wxBinding(params) {
    return request('/user/weixinBinding', {
        type: 'formData',
        method: 'POST',
        params
    });
}

//用户绑定平台账号
export function wxUnbound(params) {
    return request('/user/weixinUnbound', {
        method: 'GET',
        params
    });
}

export function getUserInfo(params) {
    return request('/user/getuserinfo', {
        method: 'GET',
        params
    });
}

export function logOut() {
    return request('/user/logout', {
        method: 'POST'
    });
}

// 发送邮箱验证码
export function getEmailCode(params) {
    return request('/user/getEmailCode', {
        method: 'get',
        params
    });
}

// 注册
export function register(params) {
    return request('/user/register', {
        type: 'formData',
        method: 'POST',
        params
    });
}

// 邮箱绑定
export function bindEmail(params) {
    return request('/user/bind/email', {
        method: 'POST',
        params
    });
}

// 忘记密码
export function forgetPassword(params) {
    return request('/user/verificateEmailCode', {
        type: 'formData',
        method: 'POST',
        params
    });
}

// 获取登录二维码
export function getLoginQrCode(params) {
    return request('/user/qr/code', {
        method: 'GET',
        params
    });
}

// 获取登录状态
export function getLoginQrStatus(params) {
    return request('/user/getQrState', {
        method: 'GET',
        params
    });
}